<template>
<div class="chapter">
<div class="inner_page">
<section class="couverture" epub:type="titlepage">
<a class="url" href="https://www.ivpress.com/browse/academic-titles-and-textbooks" target="_blank"><img alt="TitlePage_ebk" class="img" src="image/titlepage.jpg"/></a></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?2471775a